export default [
  {
    path: '/pickup-displays',
    name: 'pickup-display',
    meta: { requiresAuth: true },
    component: () => import('@/pages/pickup-display/index.vue')
  }
]
